import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Clear(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.375,
    stroke: "#595963",
    strokeWidth: 1.25
  }), React.createElement("path", {
    d: "M6.25 13.75L13.75 6.25",
    stroke: "#595963",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M13.75 13.75L6.25 6.25",
    stroke: "#595963",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export { Clear };
//# sourceMappingURL=Clear.js.map